var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-image",style:({'background-image': ("url(" + (require(("../assets/img/title-image/" + _vm.image + ".jpg"))) + ")")})},[_c('h1',{staticClass:"text-center h2"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }